import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';

const Hero = ({ onRequestQuote }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-24 md:pt-32 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/27083552/pexels-photo-27083552.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Modern Poultry Farm"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/85 to-gray-900/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 backdrop-blur-sm border border-emerald-400/30 rounded-full px-4 py-2 mb-6">
            <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
            <span className="text-emerald-300 text-sm font-medium">Established {mockData.company.established} • ISO Certified</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            {mockData.hero.title}
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-emerald-100 mb-4 font-medium">
            {mockData.hero.subtitle}
          </p>

          <p className="text-lg text-gray-300 mb-8 max-w-2xl leading-relaxed">
            {mockData.hero.description}
          </p>

          {/* Feature Pills */}
          <div className="flex flex-wrap gap-3 mb-10">
            {['62,000+ Layers', '60,000+ Daily Eggs', '100% Automated', 'FSSAI Licensed'].map((feature, index) => (
              <div 
                key={index}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg px-4 py-2"
              >
                <CheckCircle2 className="text-emerald-400" size={18} />
                <span className="text-white font-medium">{feature}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={onRequestQuote}
              size="lg"
              className="bg-emerald-600 hover:bg-emerald-700 text-white text-lg px-8 py-6 shadow-xl hover:shadow-2xl transition-all hover:scale-105"
            >
              Request Quote
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button 
              onClick={scrollToContact}
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-md border-2 border-white/30 text-white hover:bg-white/20 text-lg px-8 py-6 transition-all"
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
      
      {/* Floating Stats */}
      <div className="absolute bottom-20 right-10 hidden xl:block z-10">
        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 shadow-2xl">
          <div className="text-4xl font-bold text-emerald-400 mb-1">60,000+</div>
          <div className="text-white font-medium">Fresh Eggs Daily</div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
